import { useEffect } from "react";

import { useState, useRef } from "react";
import { AnimatePresence, motion, useAnimationFrame, useMotionValue } from "framer-motion";

import multiply from "../assets/multiply_bold.png"
import checkmark from "../assets/checkmark_bold.png"

import loadingLogo from "../assets/loading_logo.png"
import QuestionCard from "../components/questioncard";
import { allQuestions, newQuestions, Question, telQuestions, woyQuestions, couQuestions, totQuestions, sibQuestions } from "../models/question";
import AutoShrinkText from "../components/autoshrink";
import { UserImage } from "./quiz";

import arrow from "../assets/arrow.png"
import pin from "../assets/pin.png"
import copy from "../assets/copy.png"

import { fetchUserData, createQuiz, fetchQuizData, loadRemoteConfig, fetchCustomsData, trackClick } from "../lib/firebase";

import { analytics, logEvent } from "../lib/firebase";

import translations from "../translations";
import Button from "../components/button";


export default function Result() {

    const [questionIndex, setQuestionIndex] = useState(-1);

    const queryParameters = new URLSearchParams(window.location.search);
    const code = queryParameters.get("code");
    const q = queryParameters.get("q");
    
    const [lang, setLang] = useState(queryParameters.get("lang") ?? "en")

    const [gameMode, setGameMode] = useState(queryParameters.get("mode") ?? "friend")

    const [user, setUser] = useState(null);
    const [quiz, setQuiz] = useState(null);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);

    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [answersByAbout, setAnswersByAbout] = useState([]);
    const [results, setResults] = useState([]);

    const [username, setUsername] = useState(queryParameters.get("name") ?? "");

    const [hasApp, setHasApp] = useState(false);

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let storeLink = "https://apps.apple.com/us/app/bondz-friends-ranking/id6748461951";
  
    if (/android/i.test(userAgent)) {
      storeLink = "https://play.google.com/store/apps/details?id=de.davidschreiber.bondz&listing=result";
    } else {
      storeLink = "https://apps.apple.com/us/app/bondz-who-knows-me-best/id6748461951?ppid=5242fafb-4d43-4bd8-8742-ca90484b9281";
    }

    function decode(code) {
        if (code == null) { return "" }

        const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
        let result = 0;
      
        for (const char of code.toUpperCase()) {
          const index = alphabet.indexOf(char);
          if (index === -1) {
            return null;
          }
          result = result * 26 + index;
        }
      
        return result.toString().padStart(9, "0");
      }

      async function fetchQuiz() {
        fetchQuizData(q)
        .then(async (data) => {
            setQuiz(data);
            if (Array.isArray(data.questions)) {
                const questionIds = data.questions;
                const about = data.about;
                if (questionIds.filter(qid => qid.startsWith('x')).length > 0) {
                    const customsData = await fetchCustomsData(about)
                    const customs = customsData.map(item =>
                        new Question(
                            item.id,
                            "custom",
                            "text",
                            (lang) => item.text,
                            (name, lang) => "",
                            item.emoji
                        )
                      );
                    const qs = questionIds
                        .map(id => [...allQuestions, ...newQuestions, ...woyQuestions, ...telQuestions, ...totQuestions, ...couQuestions, ...sibQuestions, ...customs].find(qu => qu.id === id))
                        .filter(Boolean); 
                    setQuestions(qs);
                } else {
                    const qs = questionIds
                        .map(id => [...allQuestions, ...newQuestions, ...woyQuestions, ...telQuestions, ...totQuestions, ...couQuestions, ...sibQuestions].find(qu => qu.id === id))
                        .filter(Boolean); 
                    setQuestions(qs);
                }
                setQuestionIndex(10);
                setGameMode(["friend", "woy", "tel", "tot", "cou", "sib"][data.mode ?? 0])
            }
            setResults(data.results);
            setAnswers(data.answers);
            setAnswersByAbout(data.answersByAbout);
            if (username.length == 0) {
                if (data.uid != null && data.uid.charAt(0) === "g") {
                    setUsername(data.uid.slice(1));
                  } else {
                    setUsername("");
                }
            }
            setLoading(false);
            setFetching(false);
        })
        .catch((err) => {
            setLoading(false);
            setFetching(false);
        });
      }

      async function fetchUser() {
        const uid = decode(code)
        fetchUserData(uid)
        .then((data) => {
            if (data.state == 0) {
                setUser(data);
                if (q) {
                    fetchQuiz()
                } else {
                    setLoading(false);
                    setFetching(false);
                }
              } else {
                setLoading(false);
                setFetching(false);
              }
        })
        .catch((err) => {
            setLoading(false);
            setFetching(false);
        });
      }

      useEffect(() => {
        document.title = "BondZ Result";
        if (code != null && user == null && !fetching && code != null) {
            fetchUser()
            loadRemoteConfig()
            setHasApp(JSON.parse(localStorage.getItem("hasApp") || false))
        } else {
            setLoading(false)
        }
    }, []);

    return (
        <motion.div className="quiz-wrapper"
        >
            <motion.div className="mobile-bound"
                
            >
                {user != null && questions.length == 10 && quiz != null && quiz.results != null ?
                    
                        <div className="quiz-vstack">
                            <div className="quiz-box">
                                {questions.map((q, i) => {
                                    const index = i - questionIndex;
                                    const scale = i > questionIndex + 2 ? 0.1 : Math.min(Math.max(0, 1 - index * 0.1), 1)
                                    const yOffset = Math.min(index * -36, 0)
                                    const brightness = 1 - (index * 0.2)
                                    const xOffset = questionIndex > i ? 402 : 0
                                    return (
                                        <motion.div
                                        key={i}
                                        className="question-card__box"
                                        initial={{
                                            scale: scale,
                                            x: xOffset,
                                            y: yOffset,
                                            zIndex: 10 - i,
                                            filter: `brightness(${brightness})`
                                        }}
                                        animate={{
                                            scale: scale,
                                            x: xOffset,
                                            y: yOffset * scale,
                                            zIndex: 10 - i,
                                            filter: `brightness(${brightness})`
                                        }}
                                        transition={{
                                            type: "spring",
                                            stiffness: 240,  
                                            damping: 24,      
                                        }}
                                        >
                                            <QuestionCard question={q} name={user.name} key={i} style={{ top: `${i * 15}px` }} index={i} text={answers != null && answers.length > i ? answers[i] : ""} lang={lang} answersName={username} gameMode={gameMode} result={results != null && results.length > i ? results[i] : null} answerByAbout={answersByAbout != null && answersByAbout.length > i ? answersByAbout[i] : null} hasApp={true} currentIndex={questionIndex} />
                                        </motion.div>
                                    )
                                })}
                                <StartCard questionIndex={questionIndex} user={user} gameMode={gameMode} questions={questions} lang={lang} username={username} />
                                <ResultCard questionIndex={questionIndex} user={user} username={username} gameMode={gameMode} lang={lang} code={code} results={results} hasApp={hasApp} />
                            </div>
                            <Controls questionIndex={questionIndex} setQuestionIndex={setQuestionIndex} />
                        </div>
                :
                    !loading ?
                    <ErrorBox title={(translations[lang] || translations.en).invalidLink.title} description={(translations[lang] || translations.en).invalidLink.text} />
                    :
                    <div className="loadingbox">
                        <motion.img src={loadingLogo}
                        animate={{
                            scale: [1, 1.04, 1],
                            opacity: [0.6, 1, 0.6], 
                            filter: [
                              "drop-shadow(0 0 0px rgba(255,255,255,0.1))",
                              "drop-shadow(0 0 18px rgba(255,255,255,0.2))",
                              "drop-shadow(0 0 0px rgba(255,255,255,0.1))",
                            ],
                          }}
                          transition={{
                            duration: 2.0,
                            ease: "linear",
                            repeat: Infinity,
                          }}
                        />
                    </div>
                }
                {!loading && !fetching && 
                    <QuizBottom lang={lang} user={user} questionIndex={questionIndex} setQuestionIndex={setQuestionIndex} questions={questions} storeLink={storeLink} gameMode={gameMode} hasApp={hasApp} setHasApp={setHasApp} score={results.filter(a => a).length ?? 0} creatorUid={decode(code)} />
                }
            </motion.div>
            <QuizLoader loading={loading || fetching} lang={lang} />
        </motion.div>
    )
}

function QuizLoader(props) {

    const loading = props.loading
    const lang = props.lang

    return (
        <motion.div className="quiz-loading-wrapper"
            animate={{
                maskImage: loading ? [] : [
                "radial-gradient(circle at center, transparent 0px, #141414 0px)",
                "radial-gradient(circle at center, transparent 100vmax, #141414 100vmax)",
                ],
                WebkitMaskImage: loading ? [] : [
                "radial-gradient(circle at center, transparent 0px, #141414 0px)",
                "radial-gradient(circle at center, transparent 100vmax, #141414 100vmax)",
                ],
            }}
            transition={{
                duration: 1,
                delay: 0.4
            }}
            style={{ pointerEvents: "none" }}
        >
            <div className="quiz-loading">
            <div className="quiz-loading__logo">
                <img src={loadingLogo} />
            </div>
                <div className="quiz-loading__bottom">
                    <div>{(translations[lang] || translations.en).loadingResult}</div>
                    <div className="quiz-loading__bar">
                        <div className="quiz-loading__bar-back">
                            <motion.div className="quiz-loading__bar-front"
                                initial={{
                                    width: 16
                                }}
                                animate={{
                                    width: loading ? 100 : 184
                                }}
                            ></motion.div>
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

function QuizBottom(props) {

    const lang = props.lang

    const user = props.user
    const questionIndex = props.questionIndex
    const setQuestionIndex = props.setQuestionIndex

    const questions = props.questions

    const storeLink = props.storeLink

    const gameMode = props.gameMode

    const hasApp = props.hasApp
    const setHasApp = props.setHasApp

    const score = props.score

    const [copied, setCopied] = useState(false)

    const t = translations[lang] || translations.en

    function endText(name) {
        if (gameMode == "cou" || gameMode == "sib") return t.endFomoFriends(name)
        if (gameMode == "woy" || gameMode == "tel") return t.endFomoGame
        return t.endFomo(name)
    }

    function ctaText() {
        return (gameMode == "woy" || gameMode == "tel") ? t.continuePlaying : t.createQuiz.long
    }

    const copyToClipboard = async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          setCopied(true);
        } catch (err) {
          console.error("Failed to copy:", err);
        }
      };

    return (
        <div className="quiz-bottom__wrapper">
            <div className={"quiz-bottom"}>
                {user != null &&
                    <div className="quiz-bottom__description">{endText(user.name ?? "")}</div>
                }
                <Button text={ctaText()} repeatDelay={2.0} border={gameMode == "friend"} onClick={() => {
                        window.open(storeLink, "_blank");
                        trackClick(props.creatorUid);
                        setHasApp(true);
                        localStorage.setItem("hasApp", JSON.stringify(true));
                        if (analytics) {
                            logEvent(analytics, "web_app_link_clicked", { mode: gameMode })
                        }
                    }} />
            </div>
        </div>
    )
}

export function ErrorBox(props) {

    const title = props.title ?? "Error"
    const description = props.description ?? "Something went wrong"

    return (
        <div className="error-box">
            <div className="quiz-card__text font-white">{title}</div>
            <div className="quiz-card__description">{description}</div>
        </div>
    )
}

function ResultCard(props) {

    const questionIndex = props.questionIndex
    const user = props.user
    const username = props.username
    const gameMode = props.gameMode

    const results = props.results

    const lang = props.lang

    const hasApp = props.hasApp

    function resultEmoji() {
        let score = results.filter(a => a).length ?? 0;
        if (score <= 5) {
            return "🤡"
          } else if (score <= 7) {
            return "🤝"
          } else if (score <= 9) {
            return "🔗"
          } else {
            return "💎"
          }
      }

    return (
        <motion.div
            className="question-card__box"
            initial={{
                scale: 10 > questionIndex + 2 ? 0.1 : Math.min(Math.max(0, 1 - (10 - questionIndex) * 0.1), 1),
                x: 0,
                y: Math.min((10 - questionIndex) * -36, 0),
                zIndex: 0,
                filter: `brightness(${1 - (10 - questionIndex) * 0.1})`
            }}
            animate={{
                scale: 10 > questionIndex + 2 ? 0.1 : Math.min(Math.max(0, 1 - (10 - questionIndex) * 0.1), 1),
                x: 0,
                y: Math.min((10 - questionIndex) * -36, 0) * Math.min(Math.max(0, 1 - (10 - questionIndex) * 0.1), 1),
                zIndex: 0,
                filter: `brightness(${1 - (10 - questionIndex) * 0.1})`
            }}
            transition={{
                type: "spring",
                stiffness: 240,  
                damping: 24,     
                }}
        >
            <div className="quiz-result-card">
                <motion.div className="quiz-result-card__top"
                
                > 
                    <div className="quiz-result-card__user__vstack">
                        <UserImage size={85} name={user.name} image={user.image} />
                        <div>{user.name == null ? (translations[lang] || translations.en).yourFriend : user.name}</div>
                    </div>
                    {gameMode == "friend" && <div className="quiz-result-card__emoji">
                        {resultEmoji()}
                    </div>}
                    {gameMode == "woy" && <div className="quiz-result-card__emoji">
                        👉
                    </div>}
                    {gameMode == "tel" && <div className="quiz-result-card__emoji">
                        🔮
                    </div>}
                    {gameMode == "tot" && <div className="quiz-result-card__emoji">
                        💭
                    </div>}
                    {gameMode == "sib" && <div className="quiz-result-card__emoji">
                        🍼
                    </div>}
                    {gameMode == "cou" && <div className="quiz-result-card__emoji">
                        💘
                    </div>}
                    <div className="qrestopu"
                    >
                <div className="quiz-result-card__user__vstack"
                    >
                <UserImage size={85} name={username} image={null} />
                        <div>{username.length == 0 ? (translations[lang] || translations.en).you : username}</div>
                    </div>
                    </div>
                </motion.div>
                <motion.div className="quiz-result-card__mid"
                
                >
                    {gameMode == "friend" &&
                        <motion.div className="quiz-result-card__mid__pin"
                        style={{

                        }}
                            animate={{
                                x: [0, (402 - 32 - 96 - 18 - 16) * (results.filter(a => a).length ?? 0) / 10],
                                }}
                            transition={{
                            duration: 1.0,
                            ease: "linear",
                            }}
                        >
                            <img src={pin} alt="!" />
                        </motion.div>        
                    }
            
                    {gameMode == "friend" &&
                    <motion.div 
                
                    >
                        <div className="quiz-result-card__scale"> 
                            <div className="quiz-result-card__scale__grad"> 
                            
                            </div>
                        </div>
                    </motion.div>
                    }
                    {gameMode != "friend" &&
                        <div className="quiz-result-card__boxes"> 
                        {Array.from({ length: 10 }).map((_, i) => (
                            <div className={results != null && results.length > i ? results[i] ? "checkbox_correct_small" : "checkbox_wrong_small" : "checkbox_empty_small"}>
                                {results != null && results.length > i && <img src={results[i] ? checkmark : multiply} />}
                            </div>
                        ))}
                    </div>
                    }
                    
                </motion.div>
                <motion.div 
                
                    >
                        <div className="quiz-card__labels">
                            <div className="quiz-card__text">{(translations[lang] || translations.en).resTitle((results.filter(a => a).length ?? 0))}</div>
                            <div className="quiz-card__description">{(translations[lang] || translations.en).resDes(user.name ?? "")}</div>
                        </div>
                </motion.div>
            </div>
            
        </motion.div>
    )
}

function StartCard(props) {

    const questionIndex = props.questionIndex
    const user = props.user
    const gameMode = props.gameMode
    const questions = props.questions

    const lang = props.lang
    const username = props.username

    return (
        <motion.div
            className="question-card__box"
            initial={{
                x: questionIndex >= -0 ? 402 : 0,
                zIndex: 12,
            }}
            animate={{
                x: questionIndex >= -0 ? 402 : 0,
                zIndex: 12,
            }}
            transition={{
                type: "spring",
                stiffness: 240,  
                damping: 24,    
                }}
                onClick={(e) => e.stopPropagation()}
            >
            <div className={gameMode == "friend" ? "quiz-start-card" : `quiz-start-card ${gameMode}`}>
                <div className="quiz-start-card__top">
                    <div className="quiz-start-card__images">
                        <div className="quiz-card__img__border">
                            <UserImage size={gameMode != "friend" && gameMode != "tot" ? 96 : 121} name={user.name} image={user.image} />
                        </div>
                        {gameMode != "friend" && gameMode != "tot" && 
                            <div className="quiz-card__img__border">
                                <UserImage size={96} name={username} image={null} />
                            </div>
                        }
                    </div>
                    <div className="quiz-card__labels">
                        {gameMode == "friend" && <div className={"quiz-card__text"}>{(translations[lang] || translations.en).quizOwner(user.name ?? "")}</div>}
                        {gameMode == "woy" && <div className={"quiz-card__text font-white"}>{(translations[lang] || translations.en).woy.title}</div>}
                        {gameMode == "tel" && <div className={"quiz-card__text font-white"}>{(translations[lang] || translations.en).tel.title}</div>}
                        {gameMode == "cou" && <div className={"quiz-card__text font-white"}>{(translations[lang] || translations.en).cou.title}</div>}
                        {gameMode == "tot" && <div className={"quiz-card__text font-white"}>{(translations[lang] || translations.en).tot.title}</div>}
                        {gameMode == "sib" && <div className={"quiz-card__text font-white"}>{(translations[lang] || translations.en).sib.title}</div>}
                        {gameMode == "friend" && <div className="quiz-card__description">{(translations[lang] || translations.en).startDescription(user.name ?? "")}</div>}
                        {gameMode == "woy" && <div className="quiz-card__description font-white-60">{(translations[lang] || translations.en).woy.description(user.name ?? "")}</div>}
                        {gameMode == "tel" && <div className="quiz-card__description font-white-60">{(translations[lang] || translations.en).tel.description(user.name ?? "")}</div>}
                        {gameMode == "cou" && <div className="quiz-card__description font-white-60">{(translations[lang] || translations.en).cou.description(user.name ?? "")}</div>}
                        {gameMode == "tot" && <div className="quiz-card__description font-white-60">{(translations[lang] || translations.en).tot.description(user.name ?? "")}</div>}
                        {gameMode == "sib" && <div className="quiz-card__description font-white-60">{(translations[lang] || translations.en).sib.description(user.name ?? "")}</div>}
                    </div>
                </div>
                <div className={gameMode == "friend" ? "quiz-start-card__bot" : "quiz-start-card__bot background-secondary"}>
                    {(questions.length < 10 ? allQuestions.slice(0, 10) : questions).map((q, i) => {
                        return (
                            <div>{q.emoji}</div>
                        )
                    })}
                    </div>
            </div>
            
            </motion.div>
    )
}

function Controls(props) {

    const questionIndex = props.questionIndex
    const setQuestionIndex = props.setQuestionIndex
    const gameMode = props.gameMode

    const code = props.code

    const lang = props.lang

    return (
        <div className="quiz-controls">
            <div className="quiz-controls__box">
                {questionIndex >= 0 && 
                    <motion.div className="quiz-controls__left" onClick={() => {
                        setQuestionIndex(questionIndex - 1);
                    }}
                    whileTap={{
                        scale: 0.92
                    }}
                    >
                        <img src={arrow} alt="->" />
                    </motion.div>
                }
            </div>
            <div className="quiz-controls__box">
                {questionIndex < 10 && 
                    <motion.div className="quiz-controls__right" onClick={() => {
                        setQuestionIndex(questionIndex + 1);
                    }}
                    whileTap={{
                        scale: 0.92
                    }}>
                        <img src={arrow} alt="->" />
                    </motion.div>
                }
            </div>                
        </div>
    )
}